import { FilterBarState, FilterBarStateKey } from '.';

const mutations = {
  updateFilters(
    state: FilterBarState,
    {
      page,
      key,
      value,
      resetPagination
    }: {
      page: FilterBarStateKey;
      key: string;
      value: any;
      resetPagination: boolean;
    }
  ) {
    const newPageState = {
      ...state[page],
      [key]: value
    };
    if (resetPagination) {
      newPageState.currentPage = 1;
    }

    state[page] = newPageState as any;
  },
  toggleFilters(state: FilterBarState, { page }: { page: FilterBarStateKey }) {
    state[page] = {
      ...state[page],
      enabledFilters: state[page].enabledFilters ? false : true
    } as any;
  },
  clearFilters(state: FilterBarState, { page }: { page: FilterBarStateKey }) {
    state[page] = {
      ...state[page],
      // searchTerm: "",
      filterTags: [],
      sortBy: { value: 'recommended', label: 'Default' }
    } as any;
  },
  setPageAsLoaded(
    state: FilterBarState,
    {
      page,
      count,
      totalCount,
      setCurrentPage = true
    }: {
      page: FilterBarStateKey;
      count: number;
      totalCount?: number;
      setCurrentPage: boolean;
    }
  ) {
    state[page].loading = false;
    state[page].failedToLoad = false;
    state[page].totalCount = totalCount || 0;
    state[page].count = count || 0;
    if (setCurrentPage) {
      state[page].currentPage = 1;
    }
  }
};

export default mutations;
export type FilterBarMutations = typeof mutations;
